import React from 'react';
import 'date-fns';
import PaymentDetails from './Payments/PaymentDetails';
import CampaignForm from './CampaignDetails/CampaignForm';
import ViewCampaignDetails from './Review/ViewCampaignDetails';
import CampaignAdvertisementView from './CampaignAdvertisements/CampaignAdvertisement';
import { Campaign } from '@horasys/bellplus/common/types';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { updateCampaignFormAction } from 'Stores/Slices/campaignSlice';
import { RootState } from 'Stores/store';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

const CampaignParentForm = (props: any) => {
	const { activeStep, handleNext, handleBack, role } = props;

	const { campaign } = useAppSelector((state: RootState) => state.campaign);
  const dispatch = useAppDispatch();

	const updateCampaign = (partialCampaign: Partial<Campaign>) => {
		dispatch(updateCampaignFormAction(partialCampaign));

	};

	function getStepContent(activeStep: number) {
		switch (activeStep) {
			case 0:
				return (
					<CampaignForm
						campaign={campaign}
						handleNext={handleNext}
						handleBack={handleBack}
						onSubmit={updateCampaign}
						viewMode={false}
						role={role}
					/>
				);
			case 1:
				return (
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<CampaignAdvertisementView
							handleNext={handleNext}
							handleBack={handleBack}
						/>
					</LocalizationProvider>
				);
			case 2:
				return (
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<PaymentDetails handleNext={handleNext} handleBack={handleBack} />
					</LocalizationProvider>
				);
			case 3:
				return (
					<ViewCampaignDetails
						handleNext={handleNext}
						handleBack={handleBack}
					/>
				);
			default:
				return 'Unknown step';
		}
	}

	return <>{getStepContent(activeStep)}</>;
};

export default CampaignParentForm;
